import { useEffect, useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import { API } from '@/App';

// Track page views automatically
export const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    const trackPageView = async () => {
      try {
        await axios.post(`${API}/analytics/page-view`, {
          page: location.pathname,
          referrer: document.referrer || null
        }, { withCredentials: true });
      } catch (error) {
        // Silently fail - analytics shouldn't break the app
        console.debug('Analytics tracking failed:', error);
      }
    };

    trackPageView();
  }, [location.pathname]);
};

// Track feature usage
export const useFeatureTracking = () => {
  const trackFeature = useCallback(async (feature, metadata = null) => {
    try {
      await axios.post(`${API}/analytics/feature-usage`, {
        feature,
        metadata
      }, { withCredentials: true });
    } catch (error) {
      // Silently fail
      console.debug('Feature tracking failed:', error);
    }
  }, []);

  return { trackFeature };
};

// Common feature names for consistency
export const FEATURES = {
  AUDIO_PLAY: 'audio_play',
  AUDIO_PAUSE: 'audio_pause',
  JOURNAL_SAVE: 'journal_save',
  BOOKMARK_ADD: 'bookmark_add',
  BOOKMARK_REMOVE: 'bookmark_remove',
  SHARE_CLICK: 'share_click',
  CALENDAR_VIEW: 'calendar_view',
  CALENDAR_DAY_SELECT: 'calendar_day_select',
  SETTINGS_UPDATE: 'settings_update',
  MISSED_DAYS_VIEW: 'missed_days_view',
  STREAK_VIEW: 'streak_view'
};
